<template>
  <svg class="svg-iconfont" aria-hidden="true">
    <use :xlink:href="`#${symbolName}`" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIconfont',
  props: {
    symbolName: {
      type: String,
      default: '',
      require: true
    }
  }
};
</script>

<style lang="less" scoped>
.svg-iconfont {
  overflow: hidden;

  width: 1em;
  height: 1em;

  vertical-align: -0.15em;

  fill: currentcolor;
}
</style>
